import React from 'react';
import styles from './Button.module.css';

export type ButtonVariant = 'primary' | 'secondary' | 'danger' | 'ghost' | 'warning';
export type ButtonSize    = 'sm' | 'md' | 'lg';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  icon?: React.ReactNode;
  iconPosition?: 'left' | 'right';
  loading?: boolean;
  fullWidth?: boolean;
}

const Button: React.FC<ButtonProps> = ({
  variant = 'primary',
  size = 'md',
  icon,
  iconPosition = 'left',
  loading = false,
  fullWidth = false,
  children,
  disabled,
  className = '',
  ...rest
}) => (
  <button
    className={[
      styles.btn,
      styles[variant],
      styles[size],
      fullWidth  ? styles.fullWidth  : '',
      loading    ? styles.loading    : '',
      className,
    ].filter(Boolean).join(' ')}
    disabled={disabled || loading}
    {...rest}
  >
    {loading && <span className={styles.spinner} />}
    {!loading && icon && iconPosition === 'left'  && <span className={styles.icon}>{icon}</span>}
    {children && <span>{children}</span>}
    {!loading && icon && iconPosition === 'right' && <span className={styles.icon}>{icon}</span>}
  </button>
);

export default Button;